/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/CheckedIn/Name"
  
}) {
let constantData = "Thank you "
let checkinUserDataNameValueData = fromData.useDataValue({ viewPath,
context: 'checkin',
path: 'user_data.name',
})
let constantData1 = "!"
let aggregateData = fromAggregate.join(constantData, checkinUserDataNameValueData, constantData1)
  return (<React.Fragment
>
<span
  data-testid="Name.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
{aggregateData}
</span>
{children}
</React.Fragment>)
}